import * as React from 'react';
import { useState } from 'react';
import { toast, TransferUserDept } from '@cloud/atom-ui';
import * as nls from '../nls';
import  './style.m.less';
import { TransferPersonProps, NomalDataModal, SearchDataModal, TransferUserDeptDataModal } from './interface';
import {
  handleAllSelfOnly,
  getTransferData,
  fetchRolesData,
  getRoleTransferData,
  fetchDeptUserData,
  searchDeptUsersByWord,
  toLoadMoreData,
  transferDeptSearchData,
  transferUserSearchData,
  transferRolepSearchData,
} from './dataTransfer';
import iconList from './iconList';
//@ts-ignore
import {i18n} from '@src/utils/i18n';
//@ts-ignore
import lang from '@src/utils/lang';
const language = lang.lang;
const I18N = i18n(nls);
const t = (key)=>{
  return I18N[key];
 };
const TransferPersonComp: React.FC<TransferPersonProps> = (props) => {
  const {
    params: {
      selectedList,
      getList,
      transferTabList,
      boxTitle,
      deptOnly = false,
      ifUseTabList = true,
      ifSelectDept = true,
      ifUseSelectAll = true,
      ifAllowSelfOnly = false,
      allSelfOnly = false,
      noPermission = false,
      onlyOne = false,
      sortable = true,
      onlyStaticUserGroup = false,
      searchPlaceholder = t('DefaultSelectPersonSearchPlaceholder'),
      changeUseTabList
    }
    
  } = props;
  const [groupData, setGroupData] = useState({});
  const [roleData, setRoleData] = useState({});
  const [userGroupData, setUserGroupData] = useState({});
  const [adminData, setAdminData] = useState({});
  const [data, setData] = useState(groupData);
  const [useCheckBoxGroup, setUseCheckBoxGroup] = useState(ifSelectDept);
  const [tabKey, setTabKey] = useState(transferTabList[0]);
  const [tabList, setTabList] = useState([]);
  const [judeUseTabList, setJudeUseTabList] = useState(false)
  // 依据配置参数获取tab标签数组
  const getTabList = React.useCallback(
    (transferTabList) => {
      let tmpList = [];
      const getTabItem = (item) => {
        switch (item) {
          case 'Organization':
            return { title: t('TabGroup'), key: 'Organization' };
          case 'Role':
            return { title: t('TabRole'), key: 'Role' };
          case 'UserGroup':
            return { title: t('UserGroup'), key: 'UserGroup' };
          case 'Admin':
            return { title: t('Administrator'), key: 'Admin' };
          default:
            return null;
        }
      };
      transferTabList.forEach((listItem) => {
        let tmpData = getTabItem(listItem);
        if (tmpData !== null) {
          tmpList.push(tmpData);
        }
      });
      setTabList(tmpList);
    },
    [t],
  );

  // 获取部门以及人员查询数据并封装为符合选人组件要求的数据结构
  const fatchData = React.useCallback(
    (deptCode, deptName, pageIndex, pageSize) => {
      return new Promise((resolve, reject) => {
        Promise.all([
          fetchDeptUserData(
            deptCode,
            pageIndex,
            pageSize,
            'dept',
            transferTabList.indexOf('Organization') !== -1 && (pageSize === 'all' ? ifSelectDept : true),
            noPermission,
          ),
          fetchDeptUserData(
            deptCode,
            pageIndex,
            pageSize,
            'user',
            transferTabList.indexOf('Organization') !== -1 && !deptOnly,
            noPermission,
          ),
        ]).then(
          (res) => {
            let tmpData = {};

            // 此处判断只能用双等号
            if (deptCode == '0') {
              let tmpDeptName =
                language === 'en' ? (res[0] as any).data[0].deptNameEn : (res[0] as any).data[0].deptNameCn;
              tmpData = getTransferData(deptCode, tmpDeptName, res[0], res[1], language, ifSelectDept);
            } else {
              tmpData = getTransferData(deptCode, deptName, res[0], res[1], language, ifSelectDept);
            }
            resolve(tmpData);
          },
          (errorMessage) => {
            reject([
              errorMessage,
              getTransferData(deptCode, deptName, { code: -1 }, { code: -1 }, language, ifSelectDept),
            ]);
          },
        );
      });
    },
    [transferTabList, deptOnly, language, ifSelectDept, noPermission],
  );

  // 依据type类型获取对应层级下所有该类型的数据并封装为符合选人组件要求的数据结构
  const fatchAllDataByType = React.useCallback(
    (deptCode, deptName, pageIndex, pageSize, leafType) => {
      return new Promise((resolve, reject) => {
        let ifReal = leafType === 'dept' ? ifSelectDept : true;
        fetchDeptUserData(deptCode, pageIndex, pageSize, leafType, ifReal, noPermission).then(
          (res: any) => {
            let tmpData = {};

            // 此处判断只能用双等号
            if (deptCode == '0') {
              let tmpDeptName = '';
              if (res.code === 0) {
                tmpDeptName = language === 'en' ? res.data[0].deptNameEn : res.data[0].deptNameCn;
              }
              leafType === 'dept'
                ? (tmpData = getTransferData(deptCode, tmpDeptName, res, { code: -1 }, language, ifSelectDept))
                : (tmpData = getTransferData(deptCode, tmpDeptName, { code: -1 }, res, language, ifSelectDept));
            } else {
              leafType === 'dept'
                ? (tmpData = getTransferData(deptCode, deptName, res, { code: -1 }, language, ifSelectDept))
                : (tmpData = getTransferData(deptCode, deptName, { code: -1 }, res, language, ifSelectDept));
            }
            resolve(tmpData);
          },
          (errorMessage) => {
            reject([
              errorMessage,
              getTransferData(deptCode, deptName, { code: -1 }, { code: -1 }, language, ifSelectDept),
            ]);
          },
        );
      });
    },
    [ifSelectDept, noPermission, language],
  );

  const getSearchData = (searchWord, pageIndex) => {
    return new Promise<SearchDataModal>((resolve) => {
      Promise.all([
        searchDeptUsersByWord(
          searchWord,
          pageIndex,
          10,
          'dept',
          transferTabList.indexOf('Organization') !== -1,
          noPermission,
        ),
        searchDeptUsersByWord(
          searchWord,
          pageIndex,
          10,
          'user',
          transferTabList.indexOf('Organization') !== -1 && !deptOnly,
          noPermission,
        ),
        searchDeptUsersByWord(searchWord, pageIndex, 10, 'role', transferTabList.indexOf('Role') !== -1, noPermission),
      ]).then((res) => {
        let tmpResData = { searchText: searchWord, searchList: [] };
        let DeptSearchData = transferDeptSearchData(res[0], pageIndex, language, ifSelectDept);
        let UserSearchData = transferUserSearchData(res[1], pageIndex, language);
        let RolepSearchData = transferRolepSearchData(res[2], pageIndex, language);
        if (DeptSearchData.total !== 0) {
          tmpResData.searchList.push(DeptSearchData);
        }
        if (UserSearchData.total !== 0) {
          tmpResData.searchList.push(UserSearchData);
        }
        if (RolepSearchData.total !== 0) {
          tmpResData.searchList.push(RolepSearchData);
        }
        resolve(tmpResData as SearchDataModal);
      });
    });
  };

  const onSearchData = (searchText) => getSearchData(searchText, 1);

  // 切换tab标签页，可同时指定该tab页下是否使用按类型全选
  const onTabChange = (key) => {
    switch (key) {
      case 'Organization':
        setData(groupData);
        setUseCheckBoxGroup(true && ifSelectDept);
        break;
      case 'Role':
        setData((roleData as any).fatherData);
        setUseCheckBoxGroup(false);
        break;
      case 'UserGroup':
        setData(userGroupData);
        setUseCheckBoxGroup(false);
        break;
      case 'Admin':
        setData(adminData);
        setUseCheckBoxGroup(false);
        break;
      default:
        setData(groupData);
        setUseCheckBoxGroup(true && ifSelectDept);
        break;
    }
    setTabKey(key);
  };

  // 加载下一层数据，需要按tab加载不同的数据
  const loadData = (treeNode) => {
    switch (tabKey) {
      case 'Role':
        return new Promise<TransferUserDeptDataModal>((resolve) => {
          resolve((roleData as any).childrenData.find((item) => item.key === treeNode.key));
        });
      case 'UserGroup':
        // 暂不可下钻
        break;
      case 'Admin':
        // 不可下钻
        break;
      case 'Organization':
      default:
        return new Promise<TransferUserDeptDataModal>((resolve) => {
          fatchData(treeNode.key, treeNode.title, 1, 20).then((res: TransferUserDeptDataModal) => {
            if (allSelfOnly) {
              handleAllSelfOnly(res);
            }
            resolve(res);
          });
        });
    }
  };

  // 加载对应组织层级的所有数据
  const loadAllData = (key, leafType) => {
    switch (tabKey) {
      case 'Role':
        let tmpdata1 = {};
        if (key === '角色') {
          tmpdata1 = (roleData as any).fatherData;
        }
        return new Promise<TransferUserDeptDataModal>((resolve) => {
          resolve(tmpdata1 as TransferUserDeptDataModal);
        });
      case 'Organization':
        return new Promise<TransferUserDeptDataModal>((resolve) => {
          if (!!leafType) {
            fatchAllDataByType(key, 'treeNode.title', 1, 'all', leafType).then(
              (res) => {
                if (allSelfOnly) {
                  handleAllSelfOnly(res);
                }
                resolve(res as TransferUserDeptDataModal);
              },
              (errorMessage) => {
                toast(errorMessage[0] === 'toManyToSelect' ? t('ToManyToSelectAll') : errorMessage[0]);
                resolve(errorMessage[1]);
              },
            );
          } else {
            fatchData(key, 'treeNode.title', 1, 'all').then(
              (res) => {
                if (allSelfOnly) {
                  handleAllSelfOnly(res);
                }
                resolve(res as TransferUserDeptDataModal);
              },
              (errorMessage) => {
                toast(errorMessage[0] === 'toManyToSelect' ? t('ToManyToSelectAll') : errorMessage[0]);
                resolve(errorMessage[1]);
              },
            );
          }
        });
      case 'Admin':
      default:
        break;
    }
  };

  const loadMoreData = (groupKey, typeKey, pageIndex) => {
    // 加载更多数据，按tab页区分加载，依赖父节点的key以及
    // 取对应层级获取对应类型的数据
    switch (tabKey) {
      case 'Organization':
        if (typeKey === 'dept') {
          return new Promise<NomalDataModal[]>((resolve) => {
            fetchDeptUserData(groupKey, pageIndex + 1, 20, 'dept', true, noPermission).then((res) => {
              let tmpData = toLoadMoreData(res, 'dept', language, ifSelectDept);
              if (allSelfOnly) {
                tmpData.forEach((item) => (item.selfOnly = true));
              }
              resolve(tmpData);
            });
          });
        } else {
          return new Promise<NomalDataModal[]>((resolve) => {
            fetchDeptUserData(groupKey, pageIndex + 1, 20, 'user', true, noPermission).then((res) => {
              resolve(toLoadMoreData(res, 'user', language, ifSelectDept));
            });
          });
        }
      case 'Role':
      default:
        return new Promise<NomalDataModal[]>((resolve) => {
          resolve([]);
        });
    }
  };

  const loadMoreSearchData = (searchWord, typeKey, pageIndex) => {
    // 取对应层级获取对应类型的数据
    switch (typeKey) {
      case '部门':
      case 'Dept':
        return new Promise<NomalDataModal[]>((resolve) => {
          searchDeptUsersByWord(searchWord, pageIndex + 1, 10, 'dept', true, noPermission).then((res) => {
            resolve(toLoadMoreData(res, 'dept', language, ifSelectDept));
          });
        });
      case '人员':
      case 'User':
        return new Promise<NomalDataModal[]>((resolve) => {
          searchDeptUsersByWord(searchWord, pageIndex + 1, 10, 'user', true, noPermission).then((res) => {
            resolve(toLoadMoreData(res, 'userSearch', language, true));
          });
        });
      case '角色':
      case 'Role':
        return new Promise<NomalDataModal[]>((resolve) => {
          searchDeptUsersByWord(searchWord, pageIndex + 1, 10, 'role', true, noPermission).then((res) => {
            resolve(toLoadMoreData(res, 'role', language, true));
          });
        });
      default:
        break;
    }
  };

  const handleOnChange = (selectedNodeList) => {
    const selectTmpList = selectedNodeList.map((item) => ({
      title: item.title,
      key: item.key,
      isLeaf: item.isLeaf,
      leafType: item.leafType,
      parentKey: item.parentKey,
      iconType: item.iconType,
      selfOnly: item.selfOnly ? item.selfOnly : false,
    }));
    getList(selectTmpList);
  };

  const setInitData = React.useCallback(
    (flagIndex, res, checkBoxFlag) => {
      if (flagIndex === 0) {
        setData(res);
        setUseCheckBoxGroup(checkBoxFlag && ifSelectDept);
      }
    },
    [ifSelectDept],
  );

  React.useEffect(() => {
    let indexOfOrganization = transferTabList.indexOf('Organization');
    let indexOfRole = transferTabList.indexOf('Role');
    if (indexOfOrganization !== -1) {
      fatchData(0, '', 1, 20).then((res) => {
        if (allSelfOnly) {
          handleAllSelfOnly(res);
        }
        setInitData(indexOfOrganization, res, true);
        setGroupData(res);
      });
    }
    if (indexOfRole !== -1) {
      fetchRolesData().then((res:any) => {
        res.data.length ? setJudeUseTabList(true) : setJudeUseTabList(false);
        res.data.length ? changeUseTabList(false) : changeUseTabList(true);
        let tmproleData = getRoleTransferData(0, t('TabRole'), res);
        setInitData(indexOfRole, tmproleData.fatherData, false);
        setRoleData(tmproleData);
      });
    }
    getTabList(transferTabList);
  }, [fatchData, t, language, getTabList, transferTabList, setInitData, onlyStaticUserGroup, allSelfOnly,changeUseTabList]);
  return (
    <div className={"transfer"} style={{ display: 'grid', placeItems: 'center center' }}>
      {/*@ts-ignore*/}
      <TransferUserDept
        data={data as TransferUserDeptDataModal}
        loadData={loadData}
        loadAllData={loadAllData}
        loadMoreData={loadMoreData}
        loadMoreSearchData={loadMoreSearchData}
        onSearchData={onSearchData}
        ifUseTabList={judeUseTabList}
        ifUseCheckBoxGroup={useCheckBoxGroup}
        tabList={tabList}
        defaultActiveKey={transferTabList[0]}
        onTabChange={onTabChange}
        selectedNode={selectedList}
        boxTitle={boxTitle}
        iconList={iconList}
        sortable={sortable}
        onlyOne={onlyOne}
        gutter={20}
        searchPlaceholder={searchPlaceholder}
        onChange={handleOnChange}
        selfOnlyFlag={ifAllowSelfOnly}
        useSelectAll={ifUseSelectAll}
      />
    </div>
  );
};

export default TransferPersonComp;
